import React, { useEffect, useState } from 'react';
import { useInView } from 'react-intersection-observer';
export function AboutUs() {
  const {
    ref,
    inView
  } = useInView({
    threshold: 0.1,
    triggerOnce: true
  });
  return <section id="about" className="py-20 bg-gray-50" data-id="element-15">
      <div className="container mx-auto px-4" data-id="element-16">
        <div className="text-center mb-12" data-id="element-17">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4" data-id="element-18">
            About She Wins
          </h2>
          <div className="w-24 h-1 bg-pink-600 mx-auto" data-id="element-19"></div>
        </div>

        <div ref={ref} className={`grid md:grid-cols-2 gap-8 items-center transition-all duration-1000 ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} data-id="element-20">
          <div className="relative" data-id="element-21">
            <div className="bg-pink-600 w-full h-full absolute top-4 left-4 rounded-lg" data-id="element-22"></div>
            <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/r4ghx198qvioniuadphfqh/81449d38-4222-488a-b12b-9f20b25eda97/1.jpg" alt="She Wins community" className="w-full h-auto rounded-lg relative z-10" data-id="element-23" />
          </div>

          <div className="space-y-6" data-id="element-24">
            <p className="text-lg text-gray-700" data-id="element-25">
              She Wins International Ministry is a global faith-based movement
              dedicated to helping women become whole, wise, and victorious in
              every area of life — spiritually, emotionally, mentally, and
              socially.
            </p>
            <p className="text-lg text-gray-700" data-id="element-26">
              At She Wins, we believe every woman carries divine potential and
              deserves to live free from the limitations of fear, failure, and
              societal labels. Through the teaching of God's Word, psychological
              insight, and practical mentorship, the ministry empowers women to
              rise above their past, embrace their true identity, and fulfill
              their God-given purpose.
            </p>
            <p className="text-lg text-gray-700" data-id="element-27">
              Our focus covers every aspect of a woman's life: her mind, faith,
              relationships, family, health, finances, character, and destiny.
              Each program, teaching, and outreach is designed to bring healing,
              growth, and transformation from the inside out.
            </p>
            <p className="text-lg text-gray-700" data-id="element-28">
              Whether she is broken or thriving, searching or growing, She Wins
              exists to remind every woman that she is seen, loved, and called
              to live as God intended — whole, confident, and victorious.
            </p>
          </div>
        </div>
      </div>
    </section>;
}